import { CrosstabCtor } from '@hotjar/webapp/utils/crosstab';

/**
 * Services for cross tab communication.
 *
 * It uses cookies instead of local storage events because we need cross-origin
 * communication between different schemas (http / https) for the playbacks.
 */
angular.module('hjApp').service('Crosstab', CrosstabCtor);
